
import React, {useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import StockAction from "../component/stockAction";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import moment from "moment";
import { getDeliveryPercentList, getDeliveryPercentListByDate, getGoogleSheet, getMomentumListByDate, getMyPrediction, getSectorHeatmapPerformance, getSymbolList } from "../action/api-services";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setDeliveryDateReducer } from "../redux/slice/deliveryDate";
import { useNavigate } from "react-router-dom";
import TodayPLGraph from "../component/todayPLGraph";
import { degAngle } from "../utils/utilsFunctions";
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";


const DeliveryHeatMap = () => {
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const [deliveryByDateData, setDeliveryByDateData] = useState([]);
    const [momentumByDateData, setMomentumByDateData] = useState([]);
    const [symbolData, setSymbolData] = useState([]);
    const [topGainnerSymbol, setTopGainnerSymbol] = useState([]);
    const [predictionData, setPredictionData] = useState([]);
    const [getHeatmapData, setHeatmapData] = useState([]);
    const [deliveryDataList, setDeliveryDataList] = useState([]);
    const NSE_Past_date = useSelector((state) => state.pastDate.value);
    const [series, setSeries] = useState('EQ');
    const [view, setView] = useState('Grid');
    const [heatMapMode, setHeatMapMode] = useState('Today');
    const [performance, setPerformance] = useState(7);
    const [sectorPerformanceData, setSectorPerformanceData] = useState([]);
    const [viewPerformance, setViewPerformance] = useState(false);
    const [currentSort, setCurrentSort] = useState(false);

    const [getCurrentTime, setCurrentTime] = useState('');
    const [getMaxDate, setMaxDate] = useState('');
    const [startDate, setStartDate] = useState();
    const [todayTotalStock, setTodayTotalStock] = useState(0);
    const [todayGainStock, setTodayGainStock] = useState(0);
    const [todayLossStock, setTodayLossStock] = useState(0);
    const [todayNeutralStock, setTodayNeutralStock] = useState(0);

    const [todayData, setTodayData] = useState([]);
    const [todayDate, setTodayDate] = useState();
    const [currentDate, setCurrentDate] = useState();
    const userToken = useSelector((state) => state.userToken.value);
    const navigate = useNavigate();
    
    

    const isWeekdayAllowed = (date) => {
        const day = date.getDay();    
        date.setDate(date.getDate() - 1);        
        const excludeDate = date.toISOString().split("T")[0];    
        return day !== 0 && day !== 6; // Exclude weekends and holidays
        // return day !== 0 && day !== 6 && !YearHolidays.includes(excludeDate);
    };

    const handelerSetHeatMapMode = (e) => {
        if(e.target.value === 'Delivery'){
            setStartDate(NSE_Past_date[0]?.max_date);
            setMaxDate(NSE_Past_date[0]?.max_date);
        }else{
            setStartDate(currentDate);
            setMaxDate(currentDate);
        }
        setHeatMapMode(e.target.value);
    }


useEffect(() => {
  if (!userToken) {
    navigate(`/`);
    return;
  }

  const current_date = moment(startDate).format('DDMMYY');
  const prev_date = moment(startDate).subtract(1, 'days').format('DDMMYY');

  dispatch(setDeliveryDateReducer(startDate));

  Promise.all([
    getSymbolList(series, '', userToken),
    getMyPrediction(prev_date, userToken),
    getGoogleSheet('', userToken),
    getDeliveryPercentList(current_date, '', '', '', 'EQ', '', userToken)
  ])
    .then(([symbolRes, predictionRes, sheetRes, delivery]) => {
      setSymbolData(symbolRes?.data?.data || []);
      setPredictionData(predictionRes?.data?.data || []);

      const sheetData = sheetRes?.data?.data || {};
      setTodayDate(sheetData.datetime || null);
      setCurrentDate(sheetData.datetime || null);
      setTodayData(sheetData.json_data || []);
      setDeliveryDataList(delivery.data.data);
      dispatch(setDeliveryDataReducer(delivery.data.data));
    })
    .catch((err) => {
      console.log("Error", err);
    });

}, [userToken, startDate]);

    useEffect(() =>{
        if(userToken && (heatMapMode === 'Today' || heatMapMode === 'TopGainner')){
            setLoader(false);
            let current_date = moment(startDate).format('DDMMYY');
           
            getGoogleSheet(current_date, userToken).then(function (response) {
                let Data = response.data.data.json_data;
                const filterData = []
                Data.forEach(d => {
                    if (d.CHANGEPER !== undefined && d.LTP !== undefined) {
                        // console.log("ddddd", d)
                        filterData.push({
                            symbol: d.TICKER,
                            chn_per: d.CHANGEPER,
                            close_price: d.LTP,
                            open: d.OPEN,
                            series: d.SERIES,
                            volume: d.VOLUME,
                            MARKETCAP:d.MARKETCAP
                        });
                    }
                });

                if(heatMapMode === 'Today' && getMaxDate === ''){
                    setMaxDate(response.data.data.datetime);
                }
                setCurrentTime(response.data.data.datetime);
                setStartDate(response.data.data.datetime);
                setDeliveryByDateData(filterData);

            }).catch(function (err) {console.log("Error", err) });  
        }
    }, [userToken, heatMapMode, startDate]);



    useEffect(() => {  
        if(userToken && heatMapMode === 'Delivery'){
            setLoader(false);

            let current_date = '';

            if (new Date(startDate) <= new Date(NSE_Past_date[0].max_date)) {
                current_date = moment(startDate).format('DDMMYY');
            } else {
                current_date = moment(NSE_Past_date[0].max_date).format('DDMMYY');
                setStartDate(NSE_Past_date[0].max_date);
            }

            
            getDeliveryPercentListByDate(current_date, userToken).then(function (response) {
                setDeliveryByDateData(response.data.data);
            }).catch(function (err) {console.log("Error", err) });

            setMaxDate(NSE_Past_date[0].max_date);
            // setStartDate(NSE_Past_date[0].max_date);
        }
    }, [userToken, heatMapMode, startDate]);

    useEffect(() =>{
        if(userToken){
                let payload = {
                    'date': moment(startDate).format('YYYY-MM-DD'),
                    'fromdate': performance,
                    'series': series
                }

                getSectorHeatmapPerformance(payload, userToken).then(function (response) {
                    setSectorPerformanceData(response.data.data);
                    setLoader(true);
                }).catch(function (err) {console.log("Error", err) });
        }else{
            navigate(`/`);   
        }
    }, [userToken, performance, series, startDate])


    useEffect(() => {
        if(deliveryByDateData && symbolData && predictionData){    
        
            if(heatMapMode === 'TopGainner'){

                    let filteredData = deliveryByDateData
                    .filter(item => {
                        const match = symbolData.find(s => s.symbol === item.symbol && s.active === '1');
                        const prediction = predictionData.find(p => p.symbol === item.symbol 
                            // && !isNaN(parseFloat(p.price_14_date_PL)) && parseFloat(p.price_14_date_PL) >= 1
                             && p.rsi < 90
                            //  && p.sma_angle_14 >1
                        );
                        return item.chn_per >= 5 && match && prediction;
                    })
                    .map(item => {
                        const match = symbolData.find(s => s.symbol === item.symbol && s.active === '1');
                        const prediction = predictionData?.find(p => p.symbol === item.symbol);
                        return {
                            ...item,
                            details: match,
                            prediction: prediction,
                            group_sector: match?.group_sector || ''
                        };
                    });
                    

                    // Step 2: Count group_sector occurrences
                    const sectorCounts = {};
                    filteredData.forEach(item => {
                    const sector = item.group_sector;
                    if (sector) {
                        sectorCounts[sector] = (sectorCounts[sector] || 0) + 1;
                    }
                    });

                    // Step 3: Append group_sector count to each item
                    let filterData = filteredData.map(item => ({
                    ...item,
                    group_sector_count: sectorCounts[item.group_sector] || 0
                    })).sort((a, b) => b.chn_per - a.chn_per);

                    setTopGainnerSymbol(filterData);
            }

        
            // Step 1: Create deliveryMap
            const deliveryMap = {};
            deliveryByDateData?.forEach(d => {
                if (d.symbol && d.chn_per !== undefined && d.chn_per !== '#N/A' && d.close_price !== undefined) {
                    const prediction = predictionData?.find( p => p.symbol === d.symbol);
                    const match = symbolData?.find(s => s.symbol === d.symbol && s.active === '1');
                    
                    deliveryMap[d.symbol] = {
                        chn_per: d.chn_per,
                        close_price: d.close_price,
                        price_14_per: prediction? prediction.price_14_date_PL:0,
                        sma_angle_14: prediction? prediction.sma_angle_14:0,
                        sma_angle_5: prediction? prediction.sma_angle_5:0,
                        details: match
                    };
                }
            });

            // Step 2: Build sectorSymbolsMap
            const sectorSymbolsMap = {};
            symbolData.forEach(item => {
                const sector = item.group_sector?.trim();

                if (
                    item.active === '1' &&
                    item.series === series &&
                    sector &&
                    sector !== '' &&
                    deliveryMap[item.symbol]
                ) {
                    const { chn_per, close_price, price_14_per, sma_angle_14, sma_angle_5, details } = deliveryMap[item.symbol];

                    if (!sectorSymbolsMap[sector]) {
                        sectorSymbolsMap[sector] = {
                            symbols: [],
                            gain: 0,
                            loss: 0,
                            neutral: 0,
                            movementUp: 0,
                            movementDown: 0
                        };
                    }

                    sectorSymbolsMap[sector].symbols.push({
                        symbol: item.symbol,
                        chn_per,
                        close_price,
                        price_14_per,
                        sma_angle_14,
                        sma_angle_5,
                        details
                    });

                    if (chn_per > 0) {
                        sectorSymbolsMap[sector].gain += 1;
                    } else if (chn_per === 0) {
                        sectorSymbolsMap[sector].neutral += 1;
                    } else {
                        sectorSymbolsMap[sector].loss += 1;
                    }

                    if(price_14_per > 1){
                        sectorSymbolsMap[sector].movementUp += 1;
                    }else{
                        sectorSymbolsMap[sector].movementDown += 1;
                    }
                }
            });

            // Step 3: Sort symbols inside each sector by chn_per
            for (const sector in sectorSymbolsMap) {
                sectorSymbolsMap[sector].symbols.sort((a, b) => b.chn_per - a.chn_per);
            }

            const sortedArray = Object.entries(sectorSymbolsMap)
            .map(([sector, data]) => {
                const total = data.gain + data.loss + data.neutral;
                const gainPercent = total > 0 ? (data.gain / total) * 100 : 0;
                const maxChnPer = Math.max(...data.symbols.map(s => s.chn_per || 0));

                // const totalMov = data.movementUp + data.movementDown;
                const totalMov = (data.movementUp || 0) + (data.movementDown || 0);

                const movementPer = totalMov > 0 ? (data.movementUp / totalMov) * 100 : 0;

                // const score = (gainPercent * 0.8) + (maxChnPer * 0.2); // + (movementPer * 0.4);
                const score = gainPercent;

                return [
                sector,
                {
                    ...data,
                    gainPercent: +gainPercent.toFixed(2),
                    maxChnPer: +maxChnPer.toFixed(2),
                    score: +score.toFixed(2),
                    movementPer: movementPer.toFixed(2),
                }
                ];
            })
            .sort(([, a], [, b]) => b.score - a.score);

            const rankedArray = sortedArray.map(([sector, data], index) => [
            sector,
                {
                    ...data,
                    rank: index + 1
                }
            ]);


            const sortedByGainPercent = Object.fromEntries(rankedArray);
            setHeatmapData(sortedByGainPercent);
            // console.log("ffinal", sortedByGainPercent);
            setLoader(true);


        }

    },[deliveryByDateData, symbolData, predictionData, series]);


    useEffect(() =>{
        let total_stock = 0;
        let total_gain = 0;
        let total_loss = 0;
        let total_neutral = 0;

         Object.entries(getHeatmapData).map(([sector, data], ind) => {
                total_stock += data.symbols.length
                total_gain += data.gain
                total_loss += data.loss
                total_neutral += data.neutral
         })

         setTodayTotalStock(total_stock);
         setTodayGainStock(total_gain);
         setTodayLossStock(total_loss);
         setTodayNeutralStock(total_neutral);
        //  console.log("getHeatmapData", getHeatmapData);

    }, [getHeatmapData])


    const scrollToAnchor = (e, rankID) => {
         e.preventDefault();
        const anchor = document.getElementById(rankID);
        if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth' });
        }
    };


    
    const gainnerDataSortBy = (filterType, sortby, root) => {
        let currentSort = sortby;
        setCurrentSort(sortby);
        const sortedData = [...topGainnerSymbol];

            if(currentSort === true){
                        if(root === 'child'){
                            sortedData.sort((a, b) => b['prediction'][filterType] - a['prediction'][filterType]);
                        }else{
                            sortedData.sort((a, b) => b[filterType] - a[filterType]);
                        }
                
            }else{
                if(root === 'child'){
                    sortedData.sort((a, b) => a['prediction'][filterType] - b['prediction'][filterType]);
                }else{
                    sortedData.sort((a, b) => a[filterType] - b[filterType]);
                }
                
            }
        setTopGainnerSymbol(sortedData);
    }

    const momentumDataSortBy = (filterType, sortby, root) => {
        let currentSort = sortby;
        setCurrentSort(sortby);
        const sortedData = [...momentumByDateData];

            if(currentSort === true){
                        if(root === 'child'){
                            sortedData.sort((a, b) => b['prediction'][filterType] - a['prediction'][filterType]);
                        }else{
                            sortedData.sort((a, b) => b[filterType] - a[filterType]);
                        }
                
            }else{
                if(root === 'child'){
                    sortedData.sort((a, b) => a['prediction'][filterType] - b['prediction'][filterType]);
                }else{
                    sortedData.sort((a, b) => a[filterType] - b[filterType]);
                }
                
            }
        setMomentumByDateData(sortedData);
    }

    
    
return (
    <React.Fragment>
        <div className="pageContainer">
   
                <div className="container-fluid actionControler py-3">
                     <div className="row">
                            <div className="col pe-0" style={{maxWidth:'170px'}}>
                                <div className="form-floating">
                                    <select className="form-control" id="heatmap" defaultValue={heatMapMode} onChange={(e) => {handelerSetHeatMapMode(e);}}>
                                        <option value="Today">Today</option>
                                        <option value="TopGainner">Top Gainner</option>
                                        <option value="Delivery">Delivery</option>
                                    </select>
                                    <label htmlFor="heatmap">HeatMap</label>
                                </div>
                            </div>

                            <div className="col pe-0" style={{maxWidth:'150px'}}>
                                <div className="form-floating">
                                    <select className="form-control" id="performance" defaultValue={performance} onChange={(e) => setPerformance(e.target.value)}>
                                        <option value="7">7 Days</option>
                                        <option value="14">15 Days</option>
                                    </select>
                                    <label htmlFor="performance">Performance</label>
                                </div>
                            </div>

                            <div className="col pe-0" style={{maxWidth:'150px'}}>
                                <DatePicker 
                                    placeholderText={'Select date'}
                                    className="form-control"
                                    selected={startDate} 
                                    onChange={(date) => setStartDate(date)}
                                    dateFormat="dd/MM/YYYY"
                                    minDate={moment().subtract(15, "days")}
                                    maxDate={getMaxDate}
                                    filterDate={isWeekdayAllowed}
                                />
                            </div>
                            <div className="col pe-0" style={{maxWidth:'150px'}}>
                                <div className="form-floating">
                                    <select className="form-control" id="series" defaultValue={series} onChange={(e) => setSeries(e.target.value)}>
                                        <option value="EQ">EQ</option>
                                        <option value="ETF">ETF</option>
                                    </select>
                                    <label htmlFor="series">Series</label>
                                </div>
                            </div>
                            <div className="col pe-0" style={{maxWidth:'150px'}}>
                                <div className="form-floating">
                                    <select className="form-control" id="series" defaultValue={series} onChange={(e) => setView(e.target.value)}>
                                        <option value="Grid">Grid</option>
                                        <option value="List">List</option>
                                    </select>
                                    <label htmlFor="series">View</label>
                                </div>
                            </div>

                            <div className="col barChartWidth">
                                    <div className={`form-control TodayPLDisplay ${moment(getMaxDate).format('YYYY-MM-DD') === moment(startDate).format('YYYY-MM-DD')? 'currentDate':''}`} style={{backgroundColor: todayGainStock >(todayNeutralStock + todayLossStock)? '#f3fff9':'#fff6f6'}}>
                                        <div className="todayPL">
                                            {(heatMapMode === 'Delivery')? moment(startDate).format('DD-MM-YYYY') : moment(getCurrentTime).format('DD-MM-YYYY HH:mm A')}
                                            {' — '}
                                            <span style={{color:'#28c87d'}}>
                                            {todayGainStock}</span>/{todayNeutralStock}/<span style={{color:'#fa5a5a'}}>{todayLossStock}</span> | {todayTotalStock}
                                        </div>
                                        {moment(getMaxDate).format('YYYY-MM-DD') === moment(startDate).format('YYYY-MM-DD')? <TodayPLGraph series={series} /> : ''}
                                    </div>
                            </div>

                            <div className="col ml-auto text-end">
                                <button type="button" className="performanceChart" onClick={(e) => setViewPerformance(!viewPerformance)}></button>
                            </div>
                    
                        </div>

                </div>
                {
                    (loader === false? <PageLoader />:    
                    <div className="pagewrap">
                        { topGainnerSymbol.length > 0 && heatMapMode === 'TopGainner'?
                            <>
                            <div className="sector_list">

                            </div>
                            <table>
                            <thead>
                                <tr  key="item_0_0">
                                    <th style={{width:'160px'}}>Symbol  [{topGainnerSymbol.length}]</th>
                                    <th style={{width:'15px'}}></th>
                                    <th style={{width:'40px'}}></th>
                                    <th style={{width:'150px', textAlign:'left'}}>Sector <button className="dataSort" onClick={(e)=> {e.preventDefault(); gainnerDataSortBy('group_sector_count', !currentSort, 'parent')}}></button></th>
                                    <th style={{width:'75px', textAlign:'left'}}>Indices</th>
                                    <th style={{width:'70px'}}>LTP</th>
                                    <th style={{width:'50px'}}>Chn%</th>
                                    <th style={{width:'65px'}}>14 P/L <button className="dataSort" onClick={(e)=> {e.preventDefault(); gainnerDataSortBy('price_14_date_PL', !currentSort, 'child')}}></button></th>
                                    <th style={{width:'60px'}}>RSI</th>
                                    <th style={{width:'60px'}}>ADX</th>
                                    <th style={{width:'140px'}}>14 | 9 | 5 Deg&deg; <button className="dataSort" onClick={(e)=> {e.preventDefault(); gainnerDataSortBy('sma_angle_14', !currentSort, 'child')}}></button></th>
                                    <th style={{width:'75px'}}>52 Down </th>
                                    <th style={{width:'80px'}}>52 L/H</th>
                                    <th style={{width:'50px'}}>Volume</th>
                                    <th style={{width:'50px'}}>InC Vol% </th>
                                    <th style={{width:'100px'}}>Del %</th>
                                    <th style={{width:'25px'}}>News</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                            topGainnerSymbol?.map((item, index) =>{     
                                let todayLTP = todayData.find(t => t.TICKER === item.symbol); 
                                const deliveryData = deliveryDataList?.find(d => d.symbol === item.symbol)?.stock_data; 
                                const averageVolume = Math.round(deliveryData?.reduce((sum, item) => sum + parseInt(item.ttl_trd_qty), 0) / deliveryData?.length);
                                const lastDay_volume = parseInt(deliveryData?.slice(-1)[0]['ttl_trd_qty']);
                                const currDay_volume = parseInt(item.volume);
                                let currDay_vol_per = 0;

                                if(currDay_volume > lastDay_volume){
                                        currDay_vol_per = ((currDay_volume - lastDay_volume) * 100 /lastDay_volume).toFixed(2);
                                }
                                let angle_5 = degAngle(item.prediction?.price_5, todayLTP?.LTP, 5);
                                let angle_9 = degAngle(item.prediction?.price_9, todayLTP?.LTP, 9);
                                let angle_14 = degAngle(item.prediction?.price_14, todayLTP?.LTP, 14);
                                let prevVolume = (((parseInt(item.prediction?.ttl_trd_qty) - parseInt(item.prediction?.prev_ttl_trd_qty)) * 100)/parseInt(item.prediction?.prev_ttl_trd_qty)).toFixed(2);
                                return(
                                     <tr className={`tr_${item.details.id}`}>
                                        <td className="symbolName">{item.symbol} {item.details.hotStar === '1'? <span className="hotStar"></span>:null}</td>
                                        <td><StockAction symbol={item.symbol}  delivery={false} currentPrice ={item.close_price} deliveryPer={item.delivery_per} hotStar={item.details.hotStar} myFev={item.details.myFev} eventName = "Heat Map" /></td>
                                        <td><DeliveryGraph symbol={item.symbol} todayLTP={todayLTP} date={moment(startDate).format('YYYY-MM-DD') > moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD')? moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD') : moment(startDate).format('YYYY-MM-DD') } /></td>
                                        <td style={{textAlign:'left'}}>{item.group_sector} ({item.group_sector_count})</td>
                                        <td style={{textAlign:'left'}}>
                                            {(() => {
                                                const label = item.details.nifty50? '50': item.details.nifty100? '100': item.details.nifty200? '200': item.details.nifty500? '500': item.details.totalMarket? 'TM': '';
                                                const excludedSeries = ['ETF', 'BOND', 'MF'];
                                                const showFev = item.details.myFev && !excludedSeries.includes(item.details.series);
                                                return label + (showFev ? `${label ? ', ' : ''}Fev` : '');
                                            })()}
                                        </td>
                                        <td>{(item.close_price).toFixed(2)}</td>
                                        <td>{(item.chn_per).toFixed(2)}%</td>
                                        <td style={{backgroundColor: item.prediction.price_14_date_PL > 15? '#fff89e':''}} title={`${item.prediction.price_14} | ${moment(item.prediction.price_14_date).format('DD/MM/YYYY')}`}>{(item.prediction.price_14_date_PL).toFixed(2)}%</td>
                                        <td>{(item.prediction.rsi).toFixed(2)}</td>
                                        <td>{(item.prediction.adx).toFixed(2)}</td>
                                        <td style={{textAlign:'right', backgroundColor: (parseFloat(angle_5) > parseFloat(angle_9)) && (parseFloat(angle_9) > parseFloat(angle_14))? '#e9ffe3':''}}>
                                            {angle_14}&deg; | {angle_9}&deg; | {angle_5}&deg;
                                        </td>
                                        <td><span title={item.details.high52w}>{item.details.high52w? ((item.details.high52w - item.close_price)*100/item.details.high52w).toFixed(2) + '%':'' }</span>
                                        </td>
                                        <td title={`${moment(item.details.lowDate).format('DD-MM-YY')} / ${moment(item.details.highDate).format('DD-MM-YY')}`}>{`${item.details.low52w}/${item.details.high52w}`}</td>
                                        <td style={{backgroundColor: item.prediction.trueAvgVolume !== true? '#fff5f5':'#fff'}} title={item.prediction.avg_volume.toLocaleString('en-IN')}>{item.volume.toLocaleString('en-IN')}</td>
                                        <td style={{backgroundColor: item.volume > item.prediction.ttl_trd_qty? '#cde9d7':'#fff'}} title={`${item.prediction.ttl_trd_qty} | ${averageVolume}`}>{currDay_vol_per}%</td>
                                        <td style={{backgroundColor: item.prediction.delivery_spike === "Delivery Spike" && prevVolume > 100? '#cde9d7':'#fff'}}>{prevVolume} | {item.prediction.delivery_per}%</td>
                                        <td><a className="newsicon" href={`https://www.google.com/search?q=why+${item.symbol}+share+performed+gainers+${moment(getCurrentTime).format('Do MMMM YYYY')}`} target="_blank"></a></td>
                                    </tr>
                                )
                            })
                            }
                            </tbody></table>
                            </>
                        :
                        <div className={`masonry ${view === 'List'? 'pt-4':''}`}>
                            {      
                                Object.entries(getHeatmapData).map(([sector, data], ind) => {
                                    
                                    let rank = sectorPerformanceData.findIndex((item) => item.sector === sector);
                                    return(
                                        view === "Grid"?
                                        <div className="masonry-item" id={`rank_${rank+1}`}>
                                            <h6>{ind+1}. {sector} [<span style={{color:'#28c87d'}}>{data.gain}</span>/{data.neutral}/<span style={{color:'#fa5a5a'}}>{data.loss}</span> | {data.symbols.length}] {` `} 
                                            {(data.score).toFixed(2)}%
                                            <strong>{rank+1}</strong>
                                            </h6>
                                            <table className="sector_table">
                                            <tbody>
                                            {data.symbols.map((item, index) => {
                                                let alphagreen = item.chn_per/10;
                                                let alphared = -(item.chn_per/10);
                                                const symbolName = item.symbol;
                                                let todayLTP = todayData.find(t => t.TICKER === symbolName); 
                                                // let deliveryData =  deliveryByDateData.filter((obj, index) => obj.symbol === item.symbol);

                                                // console.log("deliveryDataList", deliveryDataList);
                                                let indexNo = deliveryDataList?.findIndex(item => item.symbol === symbolName);
                                                let deliveryData = deliveryDataList[indexNo]?.stock_data;
                                                let deliveryPer = deliveryData?.slice(-1)[0].delivery_per;
                                                return(
                                                        <tr className={`tr_${item.details.id}`} key={`rowId_${ind}_${index}`}>
                                                            <td className="symbolName" title="Deg" style={{backgroundColor: item.sma_angle_14 > 14? '#fffcd0':''}}>{symbolName} {item.details.hotStar === '1'? <span className="hotStar"></span>:null}</td>
                                                            <td style={{width:'28px'}}>{item.sma_angle_14 > 14? `${item.sma_angle_14}°`:''}</td>
                                                            <td style={{width:'15px'}}><StockAction symbol={item.symbol} delivery={false} currentPrice ={item.close_price} deliveryPer={deliveryPer} hotStar={item.details.hotStar}  eventName = "Spikes" /></td>
                                                            <td style={{width:'42px'}}><DeliveryGraph symbol={item.symbol} todayLTP={todayLTP} date={moment(startDate).format('YYYY-MM-DD') > moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD')? moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD') : moment(startDate).format('YYYY-MM-DD') } />  {}</td>
                                                            <td style={{width:'55px'}}>{item.close_price}</td>
                                                            <td style={{width:'25px', background: item.chn_per > 0 ? `rgba(40,200,125, ${alphagreen})` : `rgba(250,90,90,${alphared})`}}>{item.chn_per}%</td>
                                                        </tr>
                                                )

                                            })}
                                            </tbody>
                                            </table>                                
                                        </div>
                                        :
                                        <div className="list-name pt-1 ps-3 pe-3">
                                            <h6>{ind+1}. {sector} [<span style={{color:'#28c87d'}}>{data.gain}</span>/{data.neutral}/<span style={{color:'#fa5a5a'}}>{data.loss}</span> | {data.symbols.length}] {` `} 
                                            {(data.score).toFixed(2)}% 
                                            <strong>{rank+1}</strong>
                                            </h6>
                                        </div>
                                    )
                                })
                                
                        }                    
                        </div>
                        }
                    </div>
            )
        }
        </div>
        {viewPerformance === true? 
            <div className="performnceWrap">
                    {sectorPerformanceData.map((item, index) =>{
                    return(
                    // <h6>{index+1}. {item.sector} [<span style={{color:'#28c87d'}}>{item.total_gain}</span>/{item.total_neutral}/<span style={{color:'#fa5a5a'}}>{item.total_loss}</span> | {item.total}] {` `} 
                    //         {item.weekly_gain_percent}% </h6>
                    <h6 onClick={(e) => scrollToAnchor(e, `rank_${index+1}`)}>{`${index+1}. ${item.sector} [${item.stock_count}] ${item.score}%`}</h6>
                    )
                    })}
            </div>
        : ''}
    </React.Fragment>
)

}
export default DeliveryHeatMap;